import { Button, Form, type FormInstance, Input } from 'antd';
import type React from 'react';

interface AnalysisStationFormValues {
  name: string;
  description: string;
  labId?: string;
}

interface AnalysisStationFormProps {
  form: FormInstance;
  initialValues: AnalysisStationFormValues;
  onFinish: (values: AnalysisStationFormValues) => void;
  nameValidator: (name: string) => boolean;
}

export const AnalysisStationForm: React.FC<AnalysisStationFormProps> = ({ form, initialValues, onFinish, nameValidator }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues} onFinish={onFinish}>
      <Form.Item
        name="name"
        label="Bezeichnung"
        rules={[
          { required: true, message: 'Bitte Bezeichnung eingeben' },
          { whitespace: true, message: 'Bezeichnung darf nicht nur aus Leerzeichen bestehen' },
          {
            validator: async (_, name: string) => {
              if (nameValidator(name)) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('Eine Analysestation mit dieser Bezeichnung existiert bereits'));
            },
          },
        ]}
      >
        <Input placeholder="Bezeichnung" />
      </Form.Item>
      <Form.Item name="description" label="Beschreibung">
        <Input.TextArea rows={4} placeholder="Beschreibung (optional)" />
      </Form.Item>
      {/* hack for enter button support */}
      <Button htmlType="submit" hidden />
    </Form>
  );
};
